module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/moon.svg?9a527fb6214fc14b99d8d19040e13d65";